import { carouselData } from '@/mocks/home';

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
              <i className="ri-sparkling-line"></i>
              重磅专题
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              深度专题聚焦
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              编辑团队精心策划的深度调查与专题报道
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {carouselData.map((item) => (
              <article
                key={item.id}
                className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
              >
                <div className="relative overflow-hidden aspect-[16/9]">
                  <img
                    src={item.image}
                    alt={`51吃瓜网深度专题 - ${item.title}`}
                    title={`51吃瓜网专题 - ${item.title}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    width="1000"
                    height="560"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-5 md:p-6">
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.excerpt}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}